module.exports = __webpack_public_path__ + "static/media/08102021_PWI_Animated-Header_H264_compressed.084b6ebe.mp4";